import { z } from "zod";

export const emailTestSchema = z.object({
  to: z.string().trim().email("请输入有效邮箱"),
  subject: z.string().trim().min(1).max(200).default("EDM 邮件通道测试"),
  html: z
    .string()
    .trim()
    .min(1)
    .max(20_000)
    .default("<p>这是一封来自企业电子设备管理系统的测试邮件。</p>"),
});

export const emailSettingsSchema = z.object({
  provider: z.enum(["disabled", "graph", "smtp"]),
  enabled: z.boolean().default(true),
  graphTenantId: z.string().trim().max(200).optional().nullable(),
  graphClientId: z.string().trim().max(200).optional().nullable(),
  graphClientSecret: z.string().max(500).optional().nullable(),
  graphSender: z.string().trim().email().max(320).optional().nullable(),
  smtpHost: z.string().trim().max(255).optional().nullable(),
  smtpPort: z.coerce.number().int().min(1).max(65535).optional().nullable(),
  smtpSecure: z.enum(["tls", "starttls"]).optional().nullable(),
  smtpUsername: z.string().trim().max(320).optional().nullable(),
  smtpPassword: z.string().max(500).optional().nullable(),
  smtpFrom: z.string().trim().max(320).optional().nullable(),
  smtpHeloName: z.string().trim().max(255).optional().nullable(),
  replyTo: z.string().trim().email().max(320).optional().nullable(),
});
